export default __webpack_public_path__ + "static/media/itSchool.6a88b474.png";